// postAssessmentStep.js
import { API_HOST, API_HOST_V1 } from '../constants/constants';
import useCurrentUser from '../hooks/useCurrentUser';
import axios from 'axios';
import { useContext } from 'react';
import { PartnerContext } from '../contexts';

export const postAssessmentStep = async (payload) => {
  const { token, userID, partnerID } = useCurrentUser();
  console.log('partnerID', partnerID);
  try {
    const { data } = await axios.post(`${API_HOST_V1}/workflows/next_step`, payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
        'x-dqpn-user-id': userID,
        'x-dqpn-partner-id': partnerID,
      },
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
